import { gql } from 'graphql-request';

export const GET_AGENCIES = gql`
  query ($first: Int, $after: String, $search: String, $country: String, $state: String) {
    agencies_connection(first: $first, after: $after, search: $search, country: $country, state: $state) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        type
        id
        full_name
        name
        country
        divisions {
          id
          name
        }
        required_access_code
        logo
        addresses {
          id
          type
          address1
          zip_code
          state_code
          country_code
          primary
          city_suburb
        }
      }
    }
  }
`;

export const GET_AGENCIES_PUBLIC = gql`
  query ($search: String) {
    agencies(search: $search) {
      id
      name
      logo
      type
      full_name
    }
  }
`;
